import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-ngbd-modal-confirm',
  templateUrl: './ngbd-modal-confirm.component.html',
  styleUrls: ['./ngbd-modal-confirm.component.scss']
})
export class NgbdModalConfirmComponent implements OnInit {

  @Input() title?: string;
  @Input() message: string = 'Are you sure?';
  @Input() confirmText: string = 'Yes';
  @Input() cancelText: string = 'No';
  @Input() confirmButtonClass: string = 'btn-primary';

  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
  }

}
